var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'decimalDisabled ' + (_vm.isDarkTheme ? 'is_dark' :'is_light'),style:(''+_vm.css)},[_vm._v(" "+_vm._s(_vm.prefix)+" "+_vm._s(_vm.valueWithMaskMoney())+" "+_vm._s(_vm.sufix)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }